import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { AxiosError } from 'axios'

import { errorCodes, postLogin } from '../../api/login'
import { ILocationState } from '../../types/router'
import { getConfiguration } from '../../utils/config'
import { emailRegex } from '../../utils/regexes'

import styles from './login.module.scss'

function Login() {
    const { t } = useTranslation()
    const { defaultPage } = getConfiguration()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const navigate = useNavigate()
    const location = useLocation()
    const locationState = location.state as ILocationState

    const handleSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        if (!password || !emailRegex.test(email)) {
            setError(t('no_email_password'))
            return
        }

        postLogin(email, password)
            .then((response) => {
                localStorage.setItem('accessToken', response.data.access_token)
                localStorage.setItem(
                    'refreshToken',
                    response.data.refresh_token
                )
            })
            .then(() => {
                const from = locationState?.from?.pathname || '/'
                navigate(from !== '/' ? from : defaultPage, {
                    replace: true,
                })
            })
            .catch((error) => {
                const typedError = error as AxiosError
                if (typedError.response) {
                    const code = typedError.response.status
                    code in errorCodes
                        ? setError(errorCodes[code])
                        : setError(t('login_failed'))
                } else {
                    setError(t('no_server_response'))
                }
            })
        setPassword('')
    }

    return (
        <div className={styles.login}>
            <form className={styles.login__form} onSubmit={handleSubmit}>
                <div className={styles.login__title}>{t('welcome')}</div>
                <div className={styles.login__user}>
                    <input
                        maxLength={320}
                        value={email}
                        onChange={(e) => setEmail(e.target.value.slice(0, 320))}
                        className={styles.login__input}
                        type="text"
                        id="login"
                        placeholder={t('email')}
                    />
                </div>
                <div className={styles.login__password}>
                    <input
                        maxLength={320}
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value.slice(0, 320))
                        }
                        className={styles.login__input}
                        type="password"
                        id="password"
                        placeholder={t('password')}
                    />
                </div>
                {error ? (
                    <div className={styles.login__error}>{error}</div>
                ) : null}
                <button className={styles.login__button} type="submit">
                    {t('login')}
                </button>
            </form>
        </div>
    )
}

export default Login
